import React, { ReactElement } from "react";
import { 
    gql, 
    useMutation, 
    MutationFunction 
} from "@apollo/client";
import { 
  UpdateCustomerAdminMutationMutation, 
  UpdateCustomerAdminMutationMutationVariables 
} from "../../../../../schemaTypes";

export const updateCustomerAdminMutation = gql`
  mutation UpdateCustomerAdminMutation(
        $userId: String
        $input: updateCustomerAdminInput!
    ) {
    updateCustomerAdmin(
        userId: $userId
        input: $input
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export interface WithUpdateCustomerAdmin {
  updateCustomer: MutationFunction<
    UpdateCustomerAdminMutationMutation,
    UpdateCustomerAdminMutationMutationVariables
  >;
}

interface Props {
  children: (data: WithUpdateCustomerAdmin) => ReactElement | null;
}

export const UpdateCustomerAdminController: React.FC<Props> = ({ children }) => {
  const [mutate] = useMutation<
    UpdateCustomerAdminMutationMutation,
    UpdateCustomerAdminMutationMutationVariables
  >(updateCustomerAdminMutation);

  return children({ updateCustomer: mutate });
};